export default "__VITE_ASSET__D2GXmXu7__"